import { CSSProperties } from "styled-components";
import FullLogoSvg from "ui/assets/images/full-logo.svg?react";
import LogoPurple from "ui/assets/images/logo_purple.svg?react";
import { FullLogoSize } from "./FullLogo.types";

export const FULL_LOGO_HEIGHT: Record<FullLogoSize, CSSProperties["height"]> = {
    sm: "1.5rem",
    md: "2.5rem",
};

export const FullLogoIcon = FullLogoSvg;
export const LogoPurpleIcon = LogoPurple;
